import React, { Component } from 'react';
import { Menu, MenuItem, ListItemIcon, ListItemText } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import OpenWithIcon from '@material-ui/icons/OpenWith';
import LockIcon from '@material-ui/icons/Lock';
import ScheduleIcon from '@material-ui/icons/Schedule';

class NodeContextMenu extends Component {
  render() {
    const { anchorEl, onClose, onAdd, onRename, onMove, onDelete, onPermissions, onVisibility } = this.props;

    return (
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onClose}
        anchorReference="anchorPosition"
        anchorPosition={
          anchorEl
            ? { top: anchorEl.mouseY, left: anchorEl.mouseX }
            : undefined
        }
      >
        <MenuItem onClick={onAdd}>
          <ListItemIcon>
            <AddIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Hinzufügen" />
        </MenuItem>
        
        <MenuItem onClick={onRename}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Umbenennen" />
        </MenuItem>
        
        <MenuItem onClick={onMove}>
          <ListItemIcon>
            <OpenWithIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Verschieben" />
        </MenuItem>
        
        <MenuItem onClick={onPermissions}>
          <ListItemIcon>
            <LockIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Berechtigungen" />
        </MenuItem>

        <MenuItem onClick={onVisibility}>
          <ListItemIcon>
            <ScheduleIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Sichtbarkeit festlegen" />
        </MenuItem>
        
        <MenuItem onClick={onDelete}>
          <ListItemIcon>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Löschen" />
        </MenuItem>
      </Menu>
    );
  }
}

export default NodeContextMenu;
